import { render, staticRenderFns } from "./StudyQuestionHorizontal.vue?vue&type=template&id=314a06dc&scoped=true&lang=pug"
import script from "./StudyQuestionHorizontal.vue?vue&type=script&lang=ts"
export * from "./StudyQuestionHorizontal.vue?vue&type=script&lang=ts"
import style0 from "./StudyQuestionHorizontal.vue?vue&type=style&index=0&id=314a06dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314a06dc",
  null
  
)

export default component.exports